import { Grid, Typography } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { useQuotationCallInfo } from './hook';
import { QuotationCallInfoProps } from './props';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';
import RichText from '../../../../../components/richText';

export const QuotationCallInfo = (props: QuotationCallInfoProps) => {
    const {
        formik,
        bouquets,
        channels,
        typeQuotations,
        typifications,
        subtypifications,
    } = useQuotationCallInfo(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Información de la llamada
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Call ID"
                    name="callId"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.callId}
                    errors={formik.errors.callId}
                    value={formik.values.callId}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(channels)}
                    label="Canal"
                    name="channel"
                    size="small"
                    required
                    touched={formik.touched.channel}
                    errors={formik.errors.channel}
                    value={formik.values.channel as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('channel', value)
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Información de la cotización
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(typeQuotations)}
                    label="Tipo de cotización"
                    name="typeQuotation"
                    size="small"
                    required
                    touched={formik.touched.typeQuotation}
                    errors={formik.errors.typeQuotation}
                    value={formik.values.typeQuotation as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('typeQuotation', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(bouquets)}
                    label="Ramo"
                    name="bouquet"
                    size="small"
                    required
                    touched={formik.touched.bouquet}
                    errors={formik.errors.bouquet}
                    value={formik.values.bouquet as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('bouquet', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(typifications)}
                    label="Tipificación"
                    name="typification"
                    size="small"
                    required
                    touched={formik.touched.typification}
                    errors={formik.errors.typification}
                    value={formik.values.typification as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('typification', value)
                    }
                />
            </Grid>
            {subtypifications.length > 0 && (
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(subtypifications)}
                        label="Subtipificación"
                        name="subtypification"
                        size="small"
                        required
                        touched={formik.touched.subtypification}
                        errors={formik.errors.subtypification}
                        value={formik.values.subtypification as string}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('subtypification', value)
                        }
                    />
                </Grid>
            )}
            <Grid item xs={12}>
                <RichText
                    initialContent={formik.values.body}
                    editable
                    onContentChange={(value) =>
                        formik.setFieldValue('body', value)
                    }
                />
            </Grid>
        </Grid>
    );
};
